module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/julia-gornicka-b5bcac5ba878d8fc915f073507e3dec7.webp";